import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';

export function Card({ 
  children, 
  className, 
  selected, 
  onClick, 
  hoverable = true 
}) {
  return (
    <motion.div
      whileHover={hoverable && !selected ? { scale: 1.02, y: -2 } : {}}
      whileTap={hoverable ? { scale: 0.98 } : {}}
      onClick={onClick}
      className={cn(
        "glass-card p-6 rounded-2xl cursor-pointer transition-all duration-300",
        selected 
          ? "border-brand-blue shadow-[0_0_30px_rgba(59,130,246,0.2)] bg-brand-blue/10" 
          : hoverable ? "hover:border-white/20 hover:bg-white-[0.02]" : "",
        className
      )}
    >
      {children}
    </motion.div>
  );
}